<template>
  <div
    v-show="show"
    :id="notification.id + '__toast_outer'"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
    :class="'b-toast b-toast-prepend b-toast-' + notification.type"
  >
    <div :id="notification.id" class="toast">
      <header class="toast-header">
        <strong class="mr-2">{{ $t('label.toast.' + notification.type) }}</strong>
        <!-- number of repeats -->
        <b-badge
          pill
          v-if="notification.repeat > 1"
          :class="'pill-'+notification.type"
        >{{notification.repeat}}</b-badge>
        <!-- close button -->
        <button type="button" aria-label="Close" class="close ml-auto mb-1" @click="close">
          <BIconX></BIconX>
        </button>
      </header>
      <div v-if="notification.htmlMessage" class="toast-body" v-html="notification.htmlMessage" />
      <div v-else class="toast-body">{{ notification.message }}</div>
    </div>
  </div>
</template>
<script>
import { BIconX } from "bootstrap-vue";
export default {
  name: "k-toast",
  props: ["notification"],
  data() {
    return {
      show: true,
      timeout: null,
    };
  },
  components: {
    BIconX,
  },
  mounted() {
    if (this.notification.type === "info") {
      const component = this;
      this.timeout = window.setTimeout(function () {
        if (component.timeout) component.close();
      }, this.timeToShow);
    }
  },
  methods: {
    close() {
      if (this.timeout) window.clearTimeout(this.timeout);
      this.show = false;
      this.$emit("hide");
    },
  },
  computed: {
    timeToShow() {
      const msg = this.notification.htmlMessage || this.notification.message || "";
      return 1500 + msg.length * 1000 / 25;
    }
    
  }
};
</script>